__turbopack_context__.v({
  "card": "collection-product-card-module__Ion36G__card",
  "comparePrice": "collection-product-card-module__Ion36G__comparePrice",
  "content": "collection-product-card-module__Ion36G__content",
  "ctaArea": "collection-product-card-module__Ion36G__ctaArea",
  "ctaButton": "collection-product-card-module__Ion36G__ctaButton",
  "discountBadge": "collection-product-card-module__Ion36G__discountBadge",
  "error": "collection-product-card-module__Ion36G__error",
  "image": "collection-product-card-module__Ion36G__image",
  "imageDots": "collection-product-card-module__Ion36G__imageDots",
  "imageSlide": "collection-product-card-module__Ion36G__imageSlide",
  "imageTrack": "collection-product-card-module__Ion36G__imageTrack",
  "imageWrap": "collection-product-card-module__Ion36G__imageWrap",
  "placeholder": "collection-product-card-module__Ion36G__placeholder",
  "price": "collection-product-card-module__Ion36G__price",
  "priceRow": "collection-product-card-module__Ion36G__priceRow",
  "productLink": "collection-product-card-module__Ion36G__productLink",
  "title": "collection-product-card-module__Ion36G__title",
});
